// @ts-nocheck
/* eslint-enable */
import imageUtils from 'app/shared/utils/imageUtils';
import isEmpty from 'lodash/isEmpty';
import numberUtils from 'app/shared/utils/numberUtils';

const controller = {
  checkPhotos(photos) {
    return photos.length === 0 ? imageUtils.noImageFound() : photos;
  },

  hasSinglePrice({ unit = {} }) {
    return unit?.low > 0 && unit?.high > 0 && unit.low === unit.high;
  },

  getPriceDropDisplay({ unit = {} }) {
    const currentPriceDisplay = this.getPriceSummaryDisplay({ unit });
    if (!unit.priceDrop || !currentPriceDisplay) {
      return { currentPrice: currentPriceDisplay, previousPrice: null };
    }

    // Calculate previous price from current + drop amount
    let previousLow = unit.low;
    let previousHigh = unit.high;

    if (unit.low > 0) {
      previousLow = unit.low + unit.priceDrop;
    }
    if (unit.high > 0) {
      previousHigh = unit.high + unit.priceDrop;
    }

    const previousPriceDisplay = this.getPriceSummaryDisplay({
      unit: { low: previousLow, high: previousHigh },
    });

    return {
      currentPrice: currentPriceDisplay,
      previousPrice: previousPriceDisplay,
    };
  },
  getAvailabilityDisplay({ listing = {}, unit = {} }) {
    if (!listing.active) {
      return 'N/A';
    } else if (listing.waitlisted) {
      return 'Waitlist';
    } else if (!unit.availabilityDate) {
      return 'Now';
    } else if (unit.availabilityDate) {
      const availDateArray = unit.availabilityDate.split('-');
      const month = parseInt(availDateArray[1]);
      const day = parseInt(availDateArray[2]);
      const year = parseInt(availDateArray[0]);
      return `${month}/${day}/${year}`;
    }
  },
  getPriceSummaryDisplay({ unit = {}, floorplan = {} }) {
    let low;
    let high;
    if (!isEmpty(unit)) {
      low = unit.low;
      high = unit.high;
    } else {
      low = floorplan.low;
      high = floorplan.high;
    }
    const lowDisplay = numberUtils.compact(low);
    const highDisplay = numberUtils.compact(high);
    let display = '';

    if (high > 0 && high < Infinity) {
      if (low === high) {
        display = `$${lowDisplay}`;
      } else if (low > 0) {
        display = `$${lowDisplay} - $${highDisplay}`;
      } else {
        display = `Up to $${highDisplay}`;
      }
    } else if (low > 0) {
      display = `$${lowDisplay}+`;
    }

    return display;
  },
};

export default controller;
